import { calc } from 'csx';
import { type CSSProperties } from 'typestyle/lib/types';
import * as styles from '../input/input.styles';
import StyleConstants from '../../styles.constants';

export const searchBar = (disabled: boolean): CSSProperties => styles.input(disabled, true);

export const searchBarContainer: CSSProperties = {
  position: 'relative',
};

export const searchIcon: CSSProperties = {
  color: StyleConstants.GREY_COLOR,
  position: 'absolute',
  top: calc('50% - 12px'),
  left: '12px',
};
